import React from "react";
import PropTypes from "prop-types";

const Controls = props => {
	const { crud, id, canSend } = props;

	const { deleteItem, duplicateItem, editItem, sendNow } = crud;

	const fireAction = (e, type) => {
		e.preventDefault();
		switch (type) {
			case "EDIT":
				editItem(id);
				break;
			case "DUPLICATE":
				duplicateItem(id);
				break;
			case "DELETE":
				deleteItem(id);
				break;
			case "SEND_NOW":
				sendNow(id);
				break;
			default:
				break;
		}
	};

	return (
		<div className="controls">
			{canSend && (
				<button title="send now" onClick={e => fireAction(e, "SEND_NOW")}>
					<i className="fal fa-paper-plane"> </i>
				</button>
			)}
			<button onClick={e => fireAction(e, "EDIT")}>
				<i className="fal fa-edit"> </i>
			</button>
			<button onClick={e => fireAction(e, "DUPLICATE")}>
				<i className="fal fa-clone"></i>
			</button>
			<button onClick={e => fireAction(e, "DELETE")}>
				<i className="fal fa-trash"></i>
			</button>
		</div>
	);
};

Controls.propTypes = {
	crud: PropTypes.object.isRequired,
	id: PropTypes.string.isRequired,
	canSend: PropTypes.bool,
};

export default Controls;
